module.exports = __webpack_public_path__ + "static/media/trucheros.cd0c5225.PNG";